import { MCard, MDialog } from "components/Shared";
import { EmployeeComplaintAttachmentResponse, EmployeeComplaintResponse } from "interfaces/Mueller.Business.Models.ts";
import React, { useEffect, useRef, useState } from "react";
import { DATA_TYPE_DATE_TIME, DATA_TYPE_MULTI_LINE_STRING, DATA_TYPE_STRING } from "typeConstants/dataTypes";
import EmployeeComplaintFileManager from "./EmployeeComplaintFileManager.tsx";
import { getComplaintAttachment } from "requests/employeeComplaints";
import responseHandler from "responseHandler/index.js";
import { connect } from "react-redux";

interface Props {
  complaint: EmployeeComplaintResponse,
  visible: boolean,
  onClose: () => void,
  //redux
  makeToast: (text: string, type: string) => void;
}

const EmployeeComplaintViewDialog = (props: Props) => {

  const mounted = useRef(true);

  const [attachments, setAttachments] = useState([]);
  const [isFetchingAttachments, setIsFetchingAttachments] = useState<boolean>(true);

  useEffect(() => { 
    return () => {mounted.current = false; };
  },[]);

  useEffect(() => {
    if(Object.keys(props.complaint).includes("attachments") && props.complaint.attachments.length > 0) {
      for(const attachment of props.complaint.attachments) {
        getComplaintAttachment(
          attachment.lookupKey,
          (a: EmployeeComplaintAttachmentResponse[]) => {
          setAttachments([...attachments, a]);
          },
          () => {props.makeToast("Failed to fetch attachments. Try closing and reopening the feedback", "error");},
          mounted);
      }
    }
    setIsFetchingAttachments(false);
  },[props.complaint]);

  return(<>
    {!props.complaint || isFetchingAttachments ? <></> :
    <MDialog width={800} className="complaint-view-dialog">
        <MCard
          className="complaint-view-dialog-mcard"
          title="Employee Feedback"
          actions={[{icon: "close", onClick: props.onClose}]}
          fields={[
            { key: "complaintDate", label: "Date of Feedback", editable: false, value: props.complaint.dateCreated, dataType: DATA_TYPE_DATE_TIME },
            { key: "complaintCategory", label: "Category", editable: false, value: props.complaint.categoryName, dataType: DATA_TYPE_STRING },
            { key: "complaintCustomer", label: "Customer", editable: false, value: props.complaint.customerNumber ?? "", dataType: DATA_TYPE_STRING },
            { key: "complaintControlNumber", label: "Control#", editable: false, value: props.complaint.controlIdNumber ?? "", dataType: DATA_TYPE_STRING },
            { key: "complaintDetails", label: "Feedback Details", value: props.complaint.description, dataType: DATA_TYPE_MULTI_LINE_STRING, dataTypeOptions: { wrapMultiLineText: true } },
          ]}
        />
      <div id="complaint-view-dialog-file-manager">
        <EmployeeComplaintFileManager canAddAttachments={false} complaint={props.complaint} canDeleteFiles={false} canDownloadFiles={true} />
      </div>
    </MDialog>
    }
  </>);
};

const mapDispatchToProps = dispatch => ({
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  }
});

export default connect(null, mapDispatchToProps)(EmployeeComplaintViewDialog);